import { AdditionalChannelEnum, ChannelEnum } from 'modules/auth/types/LoginRequest';

//those mapping are used since we only ever send SMS/EMAIL/WHATSAPP to the API
export const ADDITIONAL_CHANNEL_MAP: Record<AdditionalChannelEnum, ChannelEnum> = {
  [AdditionalChannelEnum.EMAIL_ADDITIONAL]: ChannelEnum.EMAIL,
  [AdditionalChannelEnum.SMS_ADDITIONAL]: ChannelEnum.SMS,
  [AdditionalChannelEnum.WHATSAPP_ADDITIONAL]: ChannelEnum.WHATSAPP,
};

export const CHANNEL_TO_ADDITIONAL: Record<ChannelEnum, AdditionalChannelEnum> = {
  [ChannelEnum.EMAIL]: AdditionalChannelEnum.EMAIL_ADDITIONAL,
  [ChannelEnum.SMS]: AdditionalChannelEnum.SMS_ADDITIONAL,
  [ChannelEnum.WHATSAPP]: AdditionalChannelEnum.WHATSAPP_ADDITIONAL,
};
